<template>
  <div v-if="visible" class="intervention">
    <div class="example card text-center mb-3">
      <div class="card-body">
        {{ t('result.context.context-example') }}
        <b>{{ query.uncached.example }}</b>
        {{ t('result.context.previous-list') }}
      </div>
    </div>
    <a class="btn btn-primary btn-sm my-3" v-if="first > 0" @click.prevent="before += 10" href="#">
      <i class="fa fa-plus"/>
    </a>
    <ul class="list-group">
      <li v-for="text in visibleTexts"
          :key="text.text.id"
          class="context-text list-group-item"
          :class="{ 'bg-lightblue': isRelated(text) }">
        <ncs-context-text :document="result.document" :text="text" :elements="text.elements" />
      </li>
    </ul>
    <a class="btn btn-primary btn-sm my-3" v-if="last < result.texts.length - 1" @click.prevent="after += 10" href="#">
      <i class="fa fa-plus"/>
    </a>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { compact, uniq } from 'lodash-es'

import { useApiStore, useNcsI18n, useFormatElements } from 'ncs'

const apiStore = useApiStore()
const { t } = useNcsI18n()

const query = computed(() => apiStore.query)
const result = computed(() => apiStore.response)

const before = ref(0)
const after = ref(0)

const visible = computed(() => query.value.type === 'intervention')

const searchedText = computed(() => result.value.texts.find(isSearched))
const sectionIds = computed(() => compact(uniq(searchedText.value.elements.flatMap(e => e.section_id))))
const sectionRefs = computed(() => compact(uniq(searchedText.value.elements.flatMap(e => e.section_ref))))

const first = computed(() => Math.max(result.value.texts.findIndex(isRelated) - before.value, 0))
const last = computed(() => Math.min(result.value.texts.findLastIndex(isRelated) + after.value, result.value.texts.length - 1))

const visibleTexts = computed(() => result.value.texts.slice(first.value, last.value + 1))

const isSearched = (text: any) => {
  return text.text.id === query.value.uncached.text
}

const isRelated = (text: any) => {
  if (isSearched(text)) return true

  return text.elements.some((e: any) => {
    const isReferenced = e?.section_id?.some((id: any) => sectionRefs.value.includes(id))
    const references = e?.section_ref?.some((id: any) => sectionIds.value.includes(id))
    return isReferenced || references
  })
}
</script>
